module.exports = "//static.hsappstatic.net/salesImages/static-1.403/crm-images/cta-image.png"